import { render } from "./PagoResultado.vue?vue&type=template&id=18b67cec&scoped=true"
import script from "./PagoResultado.vue?vue&type=script&lang=js"
export * from "./PagoResultado.vue?vue&type=script&lang=js"

import "./PagoResultado.vue?vue&type=style&index=0&id=18b67cec&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b67cec"]])

export default __exports__